import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import UserAvatar from '../userAvatar';
import { getItemById, isObjectEmpty } from '../../../utility/helpers';
import { formatDate } from '../../../utility/dateUtils';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    boxSizing: 'border-box',
    display: 'grid',
    gap: 24,
    padding: spacing(4, 0),
    width: '100%',
  },
  stepName: {
    lineHeight: '24px',
    marginLeft: spacing(15),
    marginBottom: spacing(4),
  },
  reviewersWrapper: {
    display: 'grid',
    gap: 24,
    width: '100%',
  },
  reviewerWrapper: {
    display: 'grid',
    gridTemplateColumns: 'minmax(250px,1.5fr) 1fr 1fr 1fr',
    width: '100%',
  },
  reviewer: {
    display: 'flex',
    alignItems: 'center',
  },
  reviewerLabel: {
    fontFamily: 'ProximaNova-Bold',
  },
  spacer: {
    flexShrink: 0,
    width: 60,
  },
  avatar: {
    maxWidth: 'calc(100% - 60px)',
  },
  gridItem: {
    alignSelf: 'center',
  },
  status: {
    display: 'flex',
    width: 94,
  },
  statusIcon: {
    marginRight: spacing(2),
  },
}));

function CycleReviewers({
  translations,
  allSteps,
  reviewerStatuses,
  data: steps,
}) {
  const classes = useStyles();

  const DATE_FORMAT = 'dd MMM yyyy, hh:mm a';

  return (
    <div className={classes.root}>
      {steps.map((step, index) => {
        const stepData = getItemById(allSteps, step.step_type);
        return (
          <div key={`step_${step.step_type}_${index}`} className={classes.step}>
            <Typography className={classes.stepName} variant="subtitle1">
              {stepData.shortName}
            </Typography>
            <div className={classes.reviewersWrapper}>
              {step.reviewers.map(reviewer => {
                const isCycleStarted = reviewer.total_reviews !== 0;
                const status = isCycleStarted
                  ? getItemById(reviewerStatuses, reviewer.completion_status)
                  : {};
                const { name, icon: Icon } = status;
                return (
                  <div
                    key={`reviewer_${reviewer.id}`}
                    className={classes.reviewerWrapper}
                  >
                    <div className={classes.reviewer}>
                      <div className={classes.spacer} />
                      <UserAvatar
                        className={classes.avatar}
                        labelClass={classes.reviewerLabel}
                        user={reviewer}
                        captionDescription={
                          reviewer.position ? reviewer.position.name : '-'
                        }
                        caption
                        withDescription
                        medium
                      />
                    </div>
                    <div className={classes.gridItem}>
                      {!isObjectEmpty(status) ? (
                        <div className={classes.status}>
                          <Icon className={classes.statusIcon} />
                          <Typography variant="body2">{name}</Typography>
                        </div>
                      ) : (
                        <Typography variant="subtitle1">-</Typography>
                      )}
                    </div>
                    <div className={classes.gridItem}>
                      {isCycleStarted ? (
                        <Typography variant="caption">{`${
                          translations.endsOn
                        }: ${formatDate(
                          step.end_at,
                          DATE_FORMAT
                        )}`}</Typography>
                      ) : (
                        <Typography variant="overline">-</Typography>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

CycleReviewers.propTypes = {
  translations: PropTypes.object.isRequired,
  allSteps: PropTypes.arrayOf(PropTypes.object).isRequired,
  reviewerStatuses: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CycleReviewers;
